export const fetchLessons = async (
  url: string,
  {
    arg,
  }: {
    arg: {
      target?: 'expert'
      lesson_type_name?: string
      start_date: string
      end_date: string
      is_affiliate?: boolean
      location_key?: string | null
    }
  }
) => {
  const params = new URLSearchParams({
    lesson_type_name: arg.lesson_type_name ?? '',
    start_date: arg.start_date,
    end_date: arg.end_date,
    is_affiliate: arg.is_affiliate ? 'true' : 'false',
  })

  if (arg.target) {
    params.append('target', arg.target)
  }

  if (arg.location_key) {
    params.append('location_key', arg.location_key)
  }

  const response = await fetch(`${url}?${params.toString()}`, {
    method: 'GET',
  })
  return response.json()
}
